import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    desktopContainer: {
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    filters: {
      flexGrow: 0,
      maxWidth: '45%',
      flexBasis: '45%',
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
    option: {
      '& span': {
        marginInlineStart: 20,
      },
      '& svg path': {
        stroke: variables.black10,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginInlineStart: 20,
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
  }),
);
